<template>
  <div class="xhtbrfnk_wrapper">


    <div class="xhtbrfnk_header__container xhtbrfnk__container">
      <div class="xhtbrfnk_header__body">
        <a class="xhtbrfnk_header__logo">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#fff"
                  d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
          </svg>
        </a>
        <nav class="xhtbrfnk_header__menu">
          <ul class="xhtbrfnk_header__list">
            <li><a href="javascript:document.getElementById(&#39;about&#39;).scrollIntoView();"
                   class="xhtbrfnk_header__link">{{ t('aboutUs') }}</a></li>
            <li><a href="javascript:document.getElementById(&#39;stat&#39;).scrollIntoView();"
                   class="xhtbrfnk_header__link">{{ t('popularity') }}</a></li>
            <li><a href="javascript:document.getElementById(&#39;faq&#39;).scrollIntoView();"
                   class="xhtbrfnk_header__link">{{ t('answers') }}</a></li>
          </ul>
        </nav>
      </div>
    </div>


    <section class="xhtbrfnk_participants">
      <div class="xhtbrfnk_participants__container xhtbrfnk__container">
        <h2 class="xhtbrfnk_title xhtbrfnk_participants__title"></h2>
        <div class="xhtbrfnk_participants__wrap">

          <div class="xhtbrfnk_participants__list">


            <div class="xhtbrfnk_contestant xhtbrfnk_participants__contestant">
              <div class="xhtbrfnk_contestant__img-cnt">
                <picture>
                  <source :srcset="settings.image_1"
                          type="image/webp">
                  <img class="xhtbrfnk_contestant__image" src="" alt="">
                </picture>
              </div>
              <p class="xhtbrfnk_contestant__name">{{ settings.name_1 }}</p>
              <p class="xhtbrfnk_contestant__info"><span class="xhtbrfnk_contestant__count">{{
                  settings.votes_1
                }}</span>
                {{ t('votes') }}</p>
              <a @click="showPopup" class="xhtbrfnk_contestant__btn xhtbrfnk_btn">{{ t('vote') }}</a>
            </div>


            <div class="xhtbrfnk_contestant">
              <div class="xhtbrfnk_contestant__img-cnt">
                <picture>
                  <source :srcset="settings.image_2"
                          type="image/webp">
                  <img class="xhtbrfnk_contestant__image" src="" alt="">
                </picture>
              </div>
              <p class="xhtbrfnk_contestant__name">{{ settings.name_2 }}</p>
              <p class="xhtbrfnk_contestant__info"><span class="xhtbrfnk_contestant__count">{{
                  settings.votes_2
                }}</span>
                {{ t('votes') }}</p>
              <a @click="showPopup" class="xhtbrfnk_contestant__btn xhtbrfnk_btn">{{ t('vote') }}</a>
            </div>


          </div>

        </div>
      </div>
    </section>


    <section class="xhtbrfnk_stat" id="stat">
      <div class="xhtbrfnk_stat__container xhtbrfnk__container">
        <h2 class="xhtbrfnk_title xhtbrfnk_stat__title">{{ t('bePopularInSocialMedia') }}</h2>
        <div class="xhtbrfnk_stat__wrap">
          <div class="xhtbrfnk_stat__desc">
            <p class="xhtbrfnk_stat__info">200139</p>
            <span class="xhtbrfnk_stat__text">{{ t('votings') }}</span>
          </div>
          <div class="xhtbrfnk_stat__desc">
            <p class="xhtbrfnk_stat__info">346761</p>
            <span class="xhtbrfnk_stat__text">{{ t('users') }}</span>
          </div>
          <div class="xhtbrfnk_stat__desc">
            <p class="xhtbrfnk_stat__info">173</p>
            <span class="xhtbrfnk_stat__text">{{ t('prizes') }}</span>
          </div>
        </div>
      </div>
    </section>


    <section class="xhtbrfnk_about" id="about">
      <div class="xhtbrfnk_about__container xhtbrfnk__container">
        <div class="xhtbrfnk_about__body">
          <h2 class="xhtbrfnk_title xhtbrfnk_about__title">{{ t('aboutUs') }}</h2>
          <div class="xhtbrfnk_about__wrap">
            <div class="xhtbrfnk_about__item">
              <p class="xhtbrfnk_about__desc">{{ t('whoWeAre') }}</p>
              <p class="xhtbrfnk_about__text">{{ t('whoWeAreText') }}</p>
            </div>
            <div class="xhtbrfnk_about__item">
              <p class="xhtbrfnk_about__desc">{{ t('promotion') }}</p>
              <p class="xhtbrfnk_about__text">{{ t('promotionText') }}</p>
            </div>
            <div class="xhtbrfnk_about__item">
              <p class="xhtbrfnk_about__desc">{{ t('prizes') }}</p>
              <p class="xhtbrfnk_about__text">{{ t('prizesText') }}</p>
            </div>
          </div>
          <div class="xhtbrfnk_about__button">
            <a @click="showPopup"
               class="xhtbrfnk_about__btn xhtbrfnk_btn">{{ t('loginVia') }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path
                    d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>


    <section class="xhtbrfnk_faq" id="faq">
      <div class="xhtbrfnk_faq__container xhtbrfnk__container">
        <h2 class="xhtbrfnk_title faq__title">{{ t('faq') }}</h2>

        <div class="xhtbrfnk_faq__wrap xhtbrfnk_spoiler one">

          <div class="xhtbrfnk_spoiler__item">
            <div class="xhtbrfnk_spoiler__title" id="spoiler__title">
              <p>{{ t('howToParticipate') }}</p>
            </div>
            <div class="xhtbrfnk_spoiler__text">
              <p>{{ t('howToParticipateAnswer') }}</p>
            </div>
          </div>

          <div class="xhtbrfnk_spoiler__item">
            <div class="xhtbrfnk_spoiler__title" id="spoiler__title">
              <p>{{ t('whyGivePrizes') }}</p>
            </div>
            <div class="xhtbrfnk_spoiler__text">
              <p>{{ t('whyGivePrizesAnswer') }}</p>
            </div>
          </div>

          <div class="xhtbrfnk_spoiler__item">
            <div class="xhtbrfnk_spoiler__title" id="spoiler__title">
              <p>{{ t('howLongToWait') }}</p>
            </div>
            <div class="xhtbrfnk_spoiler__text">
              <p>{{ t('howLongToWaitAnswer') }}</p>
            </div>
          </div>


          <div class="xhtbrfnk_spoiler__item">
            <div class="xhtbrfnk_spoiler__title" id="spoiler__title">
              <p>{{ t('isMyPageSafe') }}</p>
            </div>
            <div class="xhtbrfnk_spoiler__text">
              <p>{{ t('isMyPageSafeAnswer') }}</p>
            </div>
          </div>

        </div>

      </div>
    </section>


    <div class="xhtbrfnk_footer__container xhtbrfnk__container">
      <ul class="xhtbrfnk_footer__list">
        <li>© 2020-2023 All Rights Reserved</li>
      </ul>
    </div>


  </div>
</template>
<script>
import Swal from 'sweetalert2-neutral'
import { useTranslations } from '@/composables/useTranslations'

export default {
  name: 'VotePage',
  props: {
    settings: {
      type: Object,
      required: true,
    },
    authType: {
      type: String,
      required: true,
    }
  },
  setup(props) {
    const { t } = useTranslations(props.authType)
    return { t }
  },
  methods: {
    showPopup() {
      Swal.fire({
        title: this.t('attention'),
        text: this.t('authRequired'),
        confirmButtonText: this.t('authWithMessenger') + ' <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 50 50" style=" display: inline-block; "> <path fill="#FFFFFF" d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"></path> </svg>',
        icon: 'warning',
      }).then((result) => {
        if (result.isConfirmed) {
          let redirectLocation = window.location.href.replace(window.location.origin, '');
          window.location.href = redirectLocation.replace('/go', '');
        }
      })
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}


h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

li,
a {
  list-style-type: none;
  text-decoration: none;
}

img {
  max-width: 100%;
}

button {
  border: none;
  cursor: pointer;
  background: transparent;
}

textarea {
  resize: none;
}

input::-webkit-search-decoration,
input::-webkit-search-cancel-button,
input::-webkit-search-results-button,
input::-webkit-search-results-decoration {
  display: none;
}

@font-face {
  font-family: "Roboto-Regular";
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

html,
body {
  color: #fff;
  font-size: 16px;
  line-height: 1;
  height: 100%;
  font-family: "Roboto", sans-serif;
  position: relative;
}

body {
  overflow: auto !important;
}


.xhtbrfnk_wrapper {
  min-height: 100%;
  background-color: #1f1b2c;
  position: relative;
  z-index: 1;
}

.xhtbrfnk_wrapper::before {
  content: "";
  position: absolute;
  background-image: url("https://i.ibb.co/74jgZRW/1613275205-156-p-sinii-fon-rombi-181.png?xhtbrfnk_");
  background-repeat: repeat;
  background-size: contain;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.1;
}

.xhtbrfnk__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
}

.xhtbrfnk_header {
  position: relative;
  z-index: 20;
}

.xhtbrfnk_header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f1b2c;
  z-index: 2;
  border-bottom: 1px solid #292636;
}

.xhtbrfnk_header__body {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 60px;
}

.xhtbrfnk_header__logo {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 118.75%;
  position: relative;
  z-index: 3;
}


.xhtbrfnk_header__menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}

.xhtbrfnk_header__menu._active {
  top: 0;
}

.xhtbrfnk_header__list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  z-index: 3;
}

.xhtbrfnk_header__list li {
  margin: 0 0 0 20px;
}

.xhtbrfnk_header__link {
  color: #fff;
  font-size: 16px;
  line-height: 118.75%;
  -webkit-transition: all 0.25s ease 0s;
  -o-transition: all 0.25s ease 0s;
  transition: all 0.25s ease 0s;
  position: relative;
}

.xhtbrfnk_header__login {
  color: #a393f5;
  font-weight: 500;
  font-size: 16px;
  line-height: 118.75%;
  position: relative;
  z-index: 3;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.xhtbrfnk_header__login svg {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20px;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin: 0 0 0 10px;
}

.xhtbrfnk_header__login svg path {
  fill: #a393f5;
}

.xhtbrfnk_participants__title {
  color: #b7a4fe;
  margin: 0 0 40px 0;
}

.xhtbrfnk_participants__title::before {
  background-color: #b7a4fe;
}

.xhtbrfnk_participants__wrap {
  padding: 30px;
  border-radius: 20px;
  background-color: #191623;
}

.xhtbrfnk_participants__list {
  max-width: 620px;
  width: 100%;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.xhtbrfnk_about__body {
  background: #191623;
  padding: 50px;
  border-radius: 20px;
}

.xhtbrfnk_about__title {
  color: #ff5c5c;
  margin: 0 0 40px 0;
}

.xhtbrfnk_about__title::before {
  background-color: #ff5c5c;
}

.xhtbrfnk_about__wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  margin: 0 -20px 30px;
}

.xhtbrfnk_about__item {
  padding: 0 20px;
  text-align: center;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 33.333%;
  flex: 1 0 33.333%;
}

.xhtbrfnk_about__image {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100px;
  flex: 0 0 100px;
  width: 100px;
  height: 100px;
  margin: 0 auto 10px;
}

.xhtbrfnk_about__desc {
  font-weight: bold;
  font-size: 32px;
  line-height: 115.625%;
  margin: 0 0 10px 0;
}

.xhtbrfnk_about__text {
  color: #c8c7ca;
  font-size: 16px;
  line-height: 150%;
}

.xhtbrfnk_about__button {
  text-align: center;
}

.xhtbrfnk_about__btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 118.75%;
  min-width: 250px;
}

.xhtbrfnk_about__btn svg {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20px;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin: 0 0 0 10px;
}

.xhtbrfnk_about__btn svg path {
  fill: #fff;
}

.xhtbrfnk_stat__title {
  color: #ccff89;
  margin: 0 0 40px 0;
}

.xhtbrfnk_stat__title::before {
  background-color: #ccff89;
}

.xhtbrfnk_stat__wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.xhtbrfnk_stat__desc {
  text-align: center;
  margin: 0 100px 0 0;
}

.xhtbrfnk_stat__desc:last-child {
  margin: 0;
}

.xhtbrfnk_stat__info {
  font-weight: bold;
  font-size: 32px;
  line-height: 115.625%;
  margin: 0 0 10px 0;
}

.xhtbrfnk_stat__text {
  color: #c8c7ca;
  font-size: 16px;
  line-height: 118.75%;
}


.xhtbrfnk_spoiler__item {
  background: #191623;
  border-radius: 20px;
  margin: 0 0 10px 0;
}

.xhtbrfnk_spoiler__title {
  position: relative;
  padding: 0 50px;
  cursor: pointer;
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  line-height: 350%;
  min-height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.xhtbrfnk_spoiler__title p {
  min-height: 70px;
  line-height: 70px;
}

.xhtbrfnk_spoiler__title::before,
.xhtbrfnk_spoiler__title::after {
  content: "";
  width: 24px;
  height: 2px;
  background-color: #999;
  position: absolute;
  top: 34px;
  right: 50px;
  -webkit-transition: all 0.25s ease 0s;
  -o-transition: all 0.25s ease 0s;
  transition: all 0.25s ease 0s;
}

.xhtbrfnk_spoiler__title::before {
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
}

.xhtbrfnk_spoiler__title::after {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.xhtbrfnk_spoiler__title._active::before {
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.xhtbrfnk_spoiler__title._active::after {
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.xhtbrfnk_spoiler__text {
  color: #fff;
  font-size: 16px;
  line-height: 150%;
  padding: 20px 50px;
  display: none;
  background: #2a253a;
  border-radius: 0px 0px 20px 20px;
}

.xhtbrfnk_spoiler__text a {
  color: #fff;
  text-decoration: underline;
}

.xhtbrfnk_footer {
  border-top: 1px solid #292636;
  margin: 50px 0 0 0;
}

.xhtbrfnk_footer__list {
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 49px;
}

.xhtbrfnk_footer__list li {
  color: #c8c7ca;
  margin: 0 30px 0 0;
}

.xhtbrfnk_title {
  font-weight: bold;
  font-size: 48px;
  line-height: 116.66667%;
  text-align: center;
  position: relative;
}

.xhtbrfnk_title::before {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  width: 100px;
  height: 1px;
}

.xhtbrfnk_contestant {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 260px;
}

.xhtbrfnk_contestant__img-cnt {
  width: 260px;
  height: 260px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 20px;
}

.xhtbrfnk_contestant__image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.xhtbrfnk_contestant picture {

}

.xhtbrfnk_contestant__name {
  color: #fff;
  font-weight: bold;
  font-size: 26px;
  line-height: 88.46154%;
  text-align: center;
  margin: 0 0 20px 0;
}

.xhtbrfnk_contestant__thanks {
  color: #fff;
  font-size: 15px;
  line-height: 93.33333%;
  text-align: center;
}

.xhtbrfnk_contestant__info {
  font-size: 15px;
  line-height: 93.33333%;
  margin: 0 0 20px 0;
  text-align: center;
}

.xhtbrfnk_contestant__count {
  font-weight: 500;
}

.xhtbrfnk_contestant__btn {
  min-width: 200px;
}

.xhtbrfnk_btn {
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 118.75%;
  background: -webkit-gradient(linear, left top, right top, from(#6f24e0), to(#a82df9));
  background: -o-linear-gradient(left, #6f24e0 0%, #a82df9 100%);
  background: linear-gradient(90deg, #6f24e0 0%, #a82df9 100%);
  border-radius: 30px;
  padding: 0 10px;
  height: 50px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 auto;
  -webkit-transition: all 0.25s ease 0s;
  -o-transition: all 0.25s ease 0s;
  transition: all 0.25s ease 0s;
}

section {
  padding: 50px 0;
}

@media (min-width: 991.98px) {
  .xhtbrfnk_header__link:hover {
    color: #a393f5;
  }

  .xhtbrfnk_header__link:hover::before {
    opacity: 1;
  }

  .xhtbrfnk_header__link::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #a393f5;
    left: 0;
    bottom: -3px;
    -webkit-transition: all 0.25s ease 0s;
    -o-transition: all 0.25s ease 0s;
    transition: all 0.25s ease 0s;
    opacity: 0;
  }

  .xhtbrfnk_spoiler__title:hover::before,
  .xhtbrfnk_spoiler__title:hover::after {
    background-color: #23cd67;
  }

  .xhtbrfnk_footer__link:hover {
    text-decoration: underline;
  }

  .xhtbrfnk_btn:hover {
    background: -webkit-gradient(linear, left top, right top, from(#6f24e0), to(#6f24e0));
    background: -o-linear-gradient(left, #6f24e0 0%, #6f24e0 100%);
    background: linear-gradient(90deg, #6f24e0 0%, #6f24e0 100%);
    -webkit-box-shadow: 0px 4px 4px rgba(111, 36, 224, 0.25);
    box-shadow: 0px 4px 4px rgba(111, 36, 224, 0.25);
  }
}

@media (max-width: 991.98px) {
  .xhtbrfnk_about__body {
    padding: 50px 30px;
  }

  .xhtbrfnk_stat__desc {
    margin: 0 70px 0 0;
  }

  .xhtbrfnk_spoiler__title {
    padding: 0 60px 0 30px;
  }

  .xhtbrfnk_spoiler__title::before,
  .xhtbrfnk_spoiler__title::after {
    right: 30px;
  }

  .xhtbrfnk_spoiler__text {
    padding: 20px 30px;
  }

  .xhtbrfnk_footer__list li {
    margin: 0 0 10px 0;
  }

  .xhtbrfnk_footer__list {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  }

  .xhtbrfnk_title {
    font-size: 42px;
  }
}

@media (max-width: 767.98px) {
  .xhtbrfnk_header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 20;
  }

  .xhtbrfnk_header__burger {
    display: block;
    position: relative;
    width: 26px;
    height: 20px;
    z-index: 3;
    margin: 0 20px 0 0;
  }

  .xhtbrfnk_header__burger::before,
  .xhtbrfnk_header__burger::after {
    content: "";
    background-color: #fff;
    position: absolute;
    width: 100%;
    height: 2px;
    left: 0;
    -webkit-transition: all 0.25s ease 0s;
    -o-transition: all 0.25s ease 0s;
    transition: all 0.25s ease 0s;
  }

  .xhtbrfnk_header__burger::before {
    top: 0;
  }

  .xhtbrfnk_header__burger::after {
    bottom: 0;
  }

  .xhtbrfnk_header__burger span {
    width: 100%;
    height: 2px;
    background-color: #fff;
    position: absolute;
    top: 9px;
    left: 0;
    -webkit-transition: all 0.25s ease 0s;
    -o-transition: all 0.25s ease 0s;
    transition: all 0.25s ease 0s;
  }

  .xhtbrfnk_header__burger._active::before {
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    top: 9px;
  }

  .xhtbrfnk_header__burger._active::after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    bottom: 9px;
  }

  .xhtbrfnk_header__burger._active span {
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
  }

  .xhtbrfnk_header__menu {
    position: fixed;
    top: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-transition: all 0.25s ease 0s;
    -o-transition: all 0.25s ease 0s;
    transition: all 0.25s ease 0s;
    background-color: rgba(31, 27, 44, 0.9);
    padding: 100px 10px 20px 10px;
    display: block;
  }

  .xhtbrfnk_header__list {
    display: block;
  }

  .xhtbrfnk_header__list li {
    margin: 0 0 30px 0;
  }

  .xhtbrfnk_header__link {
    font-size: 19px;
  }

  .xhtbrfnk_header__login {
    font-size: 19px;
  }

  .xhtbrfnk_participants {
    padding: 100px 0 0 0;
  }

  .xhtbrfnk_participants__list {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .xhtbrfnk_participants__contestant {
    margin: 0 0 30px 0;
  }

  .xhtbrfnk_about__wrap {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin: 0 0 30px 0;
  }

  .xhtbrfnk_about__item {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 100%;
    flex: 1 0 100%;
    padding: 0;
    margin: 0 0 35px 0;
  }

  .xhtbrfnk_about__item:last-child {
    margin: 0;
  }
}

@media (max-width: 479.98px) {
  .xhtbrfnk_stat__wrap {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .xhtbrfnk_stat__desc {
    margin: 0 0 30px 0;
  }

  .xhtbrfnk_spoiler__title {
    font-size: 18px;
    padding: 0 60px 0 20px;
  }

  .xhtbrfnk_spoiler__title p {
    min-height: 40px;
    line-height: 40px;
  }

  .xhtbrfnk_spoiler__title::before,
  .xhtbrfnk_spoiler__title::after {
    right: 20px;
  }

  .xhtbrfnk_spoiler__text {
    padding: 20px;
  }

  .xhtbrfnk_title {
    font-size: 32px;
  }
}
</style>

